import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11b16828"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-home"]
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Monarch Initiative ")
const _hoisted_4 = ["aria-expanded"]
const _hoisted_5 = ["data-home", "data-expanded"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Explore ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" About ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Help ")

import { ref, computed, watch } from "vue";
import { useRoute } from "vue-router";
import { onClickOutside } from "@vueuse/core";
import TheNexus from "./TheNexus.vue";
import TheLogo from "@/assets/TheLogo.vue";
import app from "../../package.json";

/** route info */

export default /*#__PURE__*/_defineComponent({
  __name: 'TheHeader',
  setup(__props) {

const route = useRoute();

/** is nav menu expanded */
const expanded = ref(false);

/** header element */
const header = ref<HTMLElement>();

/** is home page (big) version */
const home = computed((): boolean => route.name === "Home");

/** close nav */
function close() {
  expanded.value = false;
}

/** close nav when page changes */
watch(() => route.name, close);

/** close nav when clicking outside header */
onClickOutside(header, close);

return (_ctx: any,_cache: any) => {
  const _component_AppLink = _resolveComponent("AppLink")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("header", {
    ref_key: "header",
    ref: header,
    class: "header",
    "data-home": _unref(home)
  }, [
    (_unref(home))
      ? (_openBlock(), _createBlock(TheNexus, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "title",
      title: _unref(app).version
    }, [
      _withDirectives((_openBlock(), _createBlock(_component_AppLink, {
        to: _unref(home) ? '' : '/',
        class: "logo",
        "data-home": _unref(home)
      }, {
        default: _withCtx(() => [
          _createVNode(TheLogo, { class: "image" }),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(home) ? 'h1' : 'div'), { class: "text" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        ]),
        _: 1
      }, 8, ["to", "data-home"])), [
        [_directive_tooltip, _unref(home) ? '' : 'Homepage']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "button",
        "aria-expanded": expanded.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
      }, [
        _createVNode(_component_AppIcon, {
          icon: expanded.value ? 'times' : 'bars'
        }, null, 8, ["icon"])
      ], 8, _hoisted_4)), [
        [_directive_tooltip, 
          expanded.value ? 'Close navigation menu' : 'Expand navigation menu'
        ]
      ])
    ], 8, _hoisted_2),
    _createElementVNode("nav", {
      class: "nav",
      "data-home": _unref(home),
      "data-expanded": expanded.value
    }, [
      _withDirectives((_openBlock(), _createBlock(_component_AppLink, {
        class: "link",
        to: "/explore"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })), [
        [_directive_tooltip, 'Dive right in and use Monarch']
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_AppLink, {
        class: "link",
        to: "/about"
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })), [
        [_directive_tooltip, 'Citing, licensing, sources, and other info']
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_AppLink, {
        class: "link",
        to: "/help"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      })), [
        [_directive_tooltip, 'Feedback, docs, guides, contact, and more']
      ])
    ], 8, _hoisted_5)
  ], 8, _hoisted_1))
}
}

})